import React from 'react';
import DailyUsage from './components/DailyUsage';
import HourlyUsage from './components/HourlyUsage';
import { Col, Container, Row } from 'react-bootstrap';
import ElastiCacheStoredData from './components/ElastiCacheStoredData';

const AppDashboard = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Dashboard</h3>
        </Col>
      </Row>
      <Row>
        <DailyUsage />
        <ElastiCacheStoredData />
      </Row>
      <Row>
        <HourlyUsage />
      </Row>
    </Container>
  );
};

export default AppDashboard;
